export default "__VITE_ASSET__DiFbwPew__"